import React, { useCallback, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { get } from 'lodash';
import { Keyboard } from 'react-native';
import { Input } from 'react-native-elements';
import styles from './styles';
const DescriptionField = ({
  name,
  label,
  returnKeyType,
  keyboardType,
  placeholder,
  onSubmitEditing,
  disabled,
  customLabelStyle,
  customInputContainerStyle,
  customContainerStyle,
  inputStyle,
  intinalValue,
  maxLength = 300,
  ...props
}: any) => {
  const { handleBlur, setFieldValue, errors, touched, values } =
    useFormikContext() || {};
  const onChangeText = useCallback(
    (text) => {
      setFieldValue(name, text);
    },
    [name, setFieldValue],
  );

  const isTouched = useMemo(() => {
    return get(touched, name);
  }, [touched, name]);

  const value = useMemo(() => {
    return get(values, name);
  }, [values, name]);

  const error = useMemo(() => {
    return get(errors, name);
  }, [errors, name]);

  const onReturnKeyPress = useCallback(() => {
    Keyboard.dismiss();
    if (onSubmitEditing) {
      onSubmitEditing();
    }
  }, [onSubmitEditing]);

  return (
    <Input
      {...props}
      multiline
      maxLength={maxLength}
      numberOfLines={20}
      disabled={disabled}
      value={value || intinalValue}
      style={[styles.inputContainer, inputStyle]}
      label={label}
      onChangeText={onChangeText}
      onBlur={handleBlur && handleBlur(name)}
      blurOnSubmit={false}
      underlineColorAndroid="transparent"
      renderErrorMessage={false}
      errorMessage={isTouched && error}
      errorStyle={styles.error}
      returnKeyType={returnKeyType}
      textAlignVertical={'top'}
      labelStyle={[styles.labelStyle, customLabelStyle]}
      keyboardType={keyboardType || 'default'}
      containerStyle={[styles.containerDescriptionStyle, customContainerStyle]}
      inputStyle={styles.descriptionStyle}
      inputContainerStyle={[
        styles.inputContainerStyle,
        customInputContainerStyle,
      ]}
      placeholder={placeholder}
      onSubmitEditing={onReturnKeyPress}
    />
  );
};

export default DescriptionField;
